<template>
  <p v-if="error" class="error-bar">{{ error }}</p>

  <div class="cell small-12">
    <h1>That's all for now!</h1>

    <div v-if="!isIntermediaryOnboarding">
      <p>
        We have emailed our identity verification requests to your persons with
        significant control, and your contract to the person requested.
      </p>

      <p>
        Please advise them to keep an eye out for the emails.
      </p>
    </div>

    <p>
      You'll soon receive an email once your account is setup, this will allow
      you to keep track of your company's onboarding progress.
    </p>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const error = ref(null)

const props = defineProps({
  formData: Object,
  clientInvite: Object
})

const isIntermediaryOnboarding = computed(() => {
  return props.clientInvite?.clientType === 'IntermediaryClient'
})

const validateStep = () => {
  return true
}




defineExpose({ validateStep })
</script>